import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaHome, FaEdit, FaCheckCircle } from "react-icons/fa";

const ExamThanks = () => {
  const { attemptId } = useParams();
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen bg-white flex items-center justify-center px-4 py-12"
      style={{
        minHeight: "100dvh",
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <div className="max-w-xl w-full bg-white rounded-2xl p-8 shadow-xl border border-gray-200 text-center">
        <div className="mx-auto w-20 h-20 rounded-full bg-green-50 flex items-center justify-center shadow-inner mb-6">
          <FaCheckCircle className="text-green-600 text-4xl" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Thank you!</h1>
        <p className="text-gray-700 mb-1">
          Your assessment has been submitted successfully.
        </p>
        {/* <p className="text-gray-500 mb-8 text-sm">Submission ID: {attemptId}</p> */}

        {/* Dashboard button removed per request */}
        {/* <button 
            className="flex items-center gap-2 px-5 py-2.5 bg-gray-900 hover:bg-black text-white text-sm font-semibold rounded-lg transition-all shadow-sm"
            onClick={() => navigate('/student')}
          >
            <FaHome />
            Go to Dashboard
          </button> */}
      </div>
    </div>
  );
};

export default ExamThanks;
